import * as Sentry from '@sentry/react-native';

import {
    endSentryTransaction,
    startSentryTransaction,
} from 'store/sentry/actions';
import { SentryState } from 'store/sentry/reducer.types';

import { isWeb } from 'utils/responsiveness';

import { END_SENTRY_TRANSACTION, START_SENTRY_TRANSACTION } from './constants';

const initialState: SentryState = {
    transactions: {},
};

const handlers = {
    [START_SENTRY_TRANSACTION](
        state: SentryState,
        {
            payload: { transactionName, transaction },
        }: ReturnType<typeof startSentryTransaction>,
    ): SentryState {
        return {
            ...state,
            transactions: {
                ...state.transactions,
                [transactionName]: transaction,
            },
        };
    },
    [END_SENTRY_TRANSACTION](
        state: SentryState,
        action: ReturnType<typeof endSentryTransaction>,
    ): SentryState {
        const {
            [action.payload.transactionName]: _transactionName,
            ...remainingTransactions
        } = state.transactions;

        state.transactions[action.payload.transactionName]?.end();

        return {
            ...state,
            transactions: remainingTransactions,
        };
    },
};

export default { initialState, handlers };
